<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-19 17:12:01
 * @FilePath: 
 * @Description: 领券中心页面
-->
<template>
  <div class="coupon_center_con">
    <template v-if="!showEmpty">
      <div class="coupon_img_con">
        <img v-if="topBgImgUrl" :style="{ width: '100%' }" :src="topBgImgUrl" />
        <span
          :class="topBgImgUrl ? '' : 'no_img_btn'"
          @click="handleShowRuleDialog"
          >活动说明</span
        >
      </div>
      <div>
        <div
          v-for="(v, i) in voucherList"
          :key="i"
          class="m-30 coupon_list_item"
        >
          <div class="coupon_item_top">
            <div class="coupon_list_left">
              <div class="img_con">
                <img :src="v.ImgBaseStr" alt="" />
              </div>
              <div class="left_con f-cl">
                <div>
                  <p class="c-ft-32 m-b-5">{{ v.TicketName }}</p>
                  <p v-if="v.TicketType == '优惠券'">
                    <span class="price_con">{{ v.DiscountStr }}</span>
                    <span class="c-ft-20">
                      {{ v.DiscountType == 0 ? "立减券" : "折扣券" }}
                    </span>
                  </p>
                </div>
                <div>
                  <span class="c-ft-22" style="color: #666">{{
                    v.ExpireDateDescription
                  }}</span>
                  <!-- <div class=" m-b-10 ft-24" :style="{color: '#999'}">
                  <span>有效期: </span>
                  <span>{{v.StartDate}} 至 {{v.EndDate}}</span>
                </div> -->
                </div>
                <!-- <div v-if="v.Money > 0">
                
                <div class="money">
                  <span>￥</span>
                  <span>{{ v.Money }}</span>
                </div>
              </div> -->
                <!-- <div>
                <span class="ft-20 coupon_rule_btn" @click.stop="lookDetail(v)">使用规则</span>
              </div> -->
              </div>
            </div>

            <div class="right_con p-tb-24 f-cl h-block">
              <div>
                <!-- <div class="c-ft-20 tc" v-if="v.StatusText">
                {{ v.StatusText }}
              </div> -->
                <div class="c-ft-20 tc">
                  <p style="margin-bottom: 10px">
                    已抢<span>{{ v.percentage }}%</span>
                  </p>
                  <van-progress
                    :percentage="v.percentage"
                    :show-pivot="false"
                    stroke-width="8"
                    color="#DCC494"
                  />
                </div>
              </div>
              <div class="tc c-mt-15">
                <span>
                  <van-button
                    :disabled="v.percentage >= 100"
                    :loading="v.isSubmiting"
                    loading-text="领取中"
                    color="var(--tc)"
                    size="mini"
                    @click="immediatelyReceive(v)"
                    >立即领取</van-button
                  >
                </span>
              </div>
            </div>
          </div>
          <div class="coupon_item_bottom" v-if="v.TicketType == '优惠券'">
            <div class="c-fl-bt">
              <p>满{{ v.MinConsume }}可用</p>
              <!-- <p @click="handleShowRule(v)">
                活动说明<van-icon
                  class="c-m-l-15"
                  :name="v.showRule ? 'arrow-up' : 'arrow-down'"
                />
              </p> -->
            </div>
            <!-- <div v-if="v.showRule" class="c-p-t-20">这是活动说明</div> -->
          </div>
        </div>
      </div>
    </template>
    <div class="empty_con" v-else>
      <img src="@/assets/images/activity-empty.png" alt="" />
      <p>{{ emptyText }}</p>
    </div>

    <van-popup closeable round v-model="showRuleDialog">
      <div class="p-26 rule_dialog_con">
        <p>活动时间</p>
        <div>
          {{ activityInfo.Period }}
        </div>
        <p class="m-t-20">活动说明</p>
        <div style="white-space: pre-wrap">
          {{ activityInfo.RuleText || "--" }}
        </div>
      </div>
    </van-popup>
    <van-dialog
      title="温馨提示"
      v-model="showTipsModal"
      show-cancel-button
      cancelButtonText="知道了"
      confirmButtonText="去看看"
      @confirm="handleToMyCoupon"
    >
      <div class="p-26 tip_modal">
        <p>领取成功！</p>
        <p>可在<span style="color: #dcc494">【我的优惠券】</span>中查询</p>
        <p>记得在截止日期前使用哦！</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getGetCouponInfo, takeCoupon } from "@/api/activity";
import { verifyWechatMember } from "@/utils/gFunc";
import wxConfig from "@/utils/wxConfig.js";
export default {
  name: "getCouponsCenter",
  props: {},
  data() {
    return {
      showEmpty: false,
      emptyText: "",
      topBgImgUrl: "",
      voucherList: [],
      activityInfo: {},
      showRuleDialog: false,
      showTipsModal: false,
    };
  },
  components: {},
  created() {},
  mounted() {},

  created() {
    // this.entrance = this.$route.query.e;
    this.activityId = this.$route.query.id;
    // this.addVisitHistory();
    this.voucherCenterInformation();
  },
  methods: {
    // addVisitHistory() {
    //   if (this.entrance) {
    // await this.$http('banner/addentrancehistory?entranceid=' + this.entrance).then(res => {
    //   console.log('访问量新增1')
    // })
    // }
    // },
    handleShowRuleDialog() {
      this.showRuleDialog = true;
    },
    voucherCenterInformation() {
      var _this = this;
      const params = {
        id: this.activityId,
      };
      getGetCouponInfo(params)
        .then((res) => {
          this.showEmpty = false;
          this.emptyText = "";
          this.activityInfo = { Period: res.Period, RuleText: res.RuleText };
          _this.needRegisterWechatMember = res.MustWeMember;

          // 活动背景图
          let shareImgUrl = "";
          if (res.Claims.length > 0) {
            res.Claims.forEach((element) => {
              if (element.TypeId == 2) {
                _this.topBgImgUrl = `${element.CdnUrl}/${element.Value}`;
              } else if (element.TypeId == 3) {
                shareImgUrl = `${element.CdnUrl}/${element.Value}`;
              }
            });
            // const imgItem = res.Claims.find((element) => element.TypeId == 2);
            // _this.topBgImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
          }

          if (res.EnableShare) {
            //   // 分享图
            wxConfig.WeChatShare(
              _this,
              location.href,
              res.ShareTitle,
              shareImgUrl,
              res.ShareText
            );
            //   if (res.ActivityInfo.ImageModel.ShowImage) {
            //     shareImgUrl = res.ActivityInfo.ImageModel.ShowImage.FilePath;
            //   }
          }

          if (res.DrawTicketItems && res.DrawTicketItems.length > 0) {
            const preList = res.DrawTicketItems;
            preList.forEach((nowItem) => {
              nowItem.showRule = false;
              nowItem.isSubmiting = false;
              if (nowItem.Claims.length > 0) {
                nowItem.Claims.forEach((element) => {
                  if (element.TypeId == 0) {
                    nowItem.ImgBaseStr = `${element.CdnUrl}/${element.Value}`;
                  }
                });
              }
              nowItem.percentage = nowItem.ReceiveRate;
              nowItem.DiscountStr =
                nowItem.DiscountType == 0
                  ? "￥" + nowItem.DiscountValue
                  : (nowItem.DiscountValue / 10).toFixed(1) + "折";
            });
            this.voucherList = preList;
          }
        })
        .catch((err) => {
          console.log(err.message);
          this.showEmpty = true;
          this.emptyText = err.message;
        });
    },
    handleShowRule(v) {
      console.log(v);
      v.showRule = !v.showRule;
    },
    immediatelyReceive(item) {
      console.log(this.needRegisterWechatMember);
      if (this.needRegisterWechatMember) {
        this.handleVerifyWechatMember(item);
      } else {
        this.submitGetRequest(item);
      }
    },
    handleVerifyWechatMember(item) {
      verifyWechatMember(() => {
        this.submitGetRequest(item);
      });
    },
    submitGetRequest(item) {
      item.isSubmiting = true;
      const params = {
        EventId: this.activityId,
        EventClientId: 0, //活动终端类型，0:H5 1:小程序
        ProductId: item.TicketId,
        // OpenId: "otl0OwzbJx8atHwFg6xNmK3bZwu4",
      };
      takeCoupon(params)
        .then((res) => {
          item.isSubmiting = false;
          // const res = {
          //   MessageTxt: "还可以领取1张",
          //   IsReceived: true,
          // };
          // if (res.MessageTxt) {
          //   this.$toast("领取成功 " + res.MessageTxt);
          // }
          // if (res.IsReceived) {
          this.showTipsModal = true;
          // }
          this.voucherCenterInformation();
        })
        .catch(() => {
          item.isSubmiting = false;
        });
    },
    handleCloseTipModal() {
      this.$toast("注册成功，可以领取优惠券啦");
      // this.showRegisterModal = false;
    },
    handleToMyCoupon() {
      // this.$pub.jump("couponMergeList");
      this.$router.push({
        name: "MyCouponList",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.coupon_center_con {
  background: #f3f5f9;
  min-height: 100vh;
  box-sizing: border-box;
  .empty_con {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 250px;
      margin-bottom: 20px;
    }
  }
  .coupon_img_con {
    padding: 30px 30px 0;
    position: relative;
    img {
      border-radius: 12px;
      max-height: 400px;
    }
    span {
      position: absolute;
      right: 30px;
      top: 60px;

      background: rgba(0, 0, 0, 0.5);
      padding: 8px 30px;
      color: #fff;
      border-radius: 25px 0 0 25px;
      font-size: 24px;
      &.no_img_btn {
        right: 0;
        top: 5px;
      }
    }
  }
}
.coupon_list_item {
  box-shadow: 0px 2px 6px 0px rgba(191, 191, 191, 0.5);

  border-radius: 12px;
  position: relative;

  .coupon_item_top {
    height: 168px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px 12px 0px 0px;
  }
  .coupon_item_bottom {
    background: #f8f8f8;
    padding: 20px;
    font-size: 24px;

    border-radius: 0px 0px 12px 12px;
  }
  .coupon_list_left {
    flex: 1;
    display: flex;

    box-sizing: border-box;

    .img_con {
      width: 168px;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        border-radius: 12px 0 0 0;
      }
    }
  }
}
.left_con {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  .price_con {
    color: #753a07;
    font-weight: bold;
    font-size: 32px;
    margin-right: 10px;
  }
}
.right_con {
  width: 130px;
  padding-right: 16px;
}
.voucherCenterStatements {
  padding: 30px;
  background: #fff;
  border-radius: 10px;
  font-size: 24px;
  p {
    display: flex;
    span:nth-child(1) {
      width: 130px;
    }
    span:nth-child(2) {
      color: #646464;
      flex: 1;
      a {
        display: block;
      }
    }
  }
}
.tip_modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin-bottom: 15px;
  }
}
.rule_dialog_con {
  width: 80vw;
  p {
    margin: 10px 0px;
    color: #333;
    font-weight: bold;
  }
  div {
    color: #666;
    word-break: break-all;
    line-height: 50px;
  }
}
</style>
